var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"coming-soon-screen"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-wrapper"},[_c('h1',{staticClass:"main-title title bold",domProps:{"innerHTML":_vm._s(_vm.$t('comingSoonScreen.mainTitle'))}}),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$t('comingSoonScreen.description'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }